if($(".hero-slideshow").length > 0){
  
var opt = {
  container: '.hero-slideshow',
  items: 1,
  speed: 500,
//   nav: true,
//   controls: true,
  navPosition: 'bottom',
  autoplayButton: false,
  autoplayButtonOutput: false,
  mouseDrag: true,
  swipeAngle: false,
  gutter: 0,
  preventScrollOnTouch: 'auto',
  controlsContainer: '#tiny-slider-controls',
  onInit: function(){
    console.log("init");
    setTimeout(function(){
      $(".hero-slideshow .slideshow-slide.tns-slide-active:eq(0) .slideshow-text").addClass("animated");
    }, 1000);      
  }
};

var elem = $(".hero-slideshow");
  
opt.autoplay = elem.data('tns-autoplay');
opt.autoplayTimeout = elem.data('tns-autoplay-speed');
opt.nav = elem.data('tns-dots');
opt.controls = elem.data('tns-nav');

var slider = tns(opt);

var customizedFunction = function (info, eventName) {
  // direct access to info object
//   console.log(info.event);
  $(".hero-slideshow .slideshow-slide .slideshow-text").removeClass("animated");
  $(".hero-slideshow .slideshow-slide.tns-slide-active:eq(0) .slideshow-text").addClass("animated");  
}

// bind function to event
slider.events.on('transitionEnd', customizedFunction);

}